var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff9494",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.998 511.998",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M508.459,234.673c-58.646-74.851-105.918-112.122-148.771-117.296c-35.93-4.334-60.763,15.159-78.886,29.397 c-9.63,7.567-18.728,14.714-24.801,14.714c-6.072,0-15.169-7.147-24.801-14.714c-18.122-14.236-42.951-33.738-78.885-29.397 C109.463,122.55,62.19,159.822,3.544,234.673c-4.722,6.025-4.729,14.558,0,20.594c24.84,31.703,63.307,65.537,102.899,90.504 c35.787,22.566,90.785,49.467,149.559,49.467c58.776,0,113.773-26.901,149.559-49.467c39.593-24.967,78.06-58.799,102.899-90.503 C513.205,249.211,513.151,240.661,508.459,234.673z M256.002,361.845c-76.543,0-155.348-53.781-201.94-100.179h115.839 c13.38,0,25.958,5.21,35.419,14.671c16.341,16.342,33.511,24.511,50.681,24.511c17.172,0,34.342-8.17,50.683-24.511 c9.46-9.46,22.039-14.671,35.419-14.671h115.839C411.352,308.064,332.546,361.845,256.002,361.845z M342.104,228.274 c-22.3,0-43.264,8.683-59.031,24.451c-19.482,19.48-34.661,19.478-54.141,0c-15.767-15.768-36.731-24.451-59.031-24.451H51.956 c41.566-48.268,76.601-74.394,104.362-77.744c22.204-2.695,37.771,9.553,54.254,22.503c13.672,10.74,27.81,21.848,45.43,21.848 c17.621,0,31.759-11.108,45.43-21.848c16.487-12.952,32.063-25.186,54.256-22.503c27.759,3.35,62.794,29.476,104.36,77.744 H342.104z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLips);
export default __webpack_public_path__ + "static/media/lips.ac4b9b58ec81bf06ec71333ca168e6fd.svg";
export { ForwardRef as ReactComponent };